module.exports = __webpack_public_path__ + "static/media/edit.72322324.svg";